// Shared Entry Point functions and constants between Vue Apps
import { createI18n } from 'vue-i18n';
import { createApp } from 'vue';
import PayLaterWidget from './components/payLaterWidget/PayLaterWidget';
import payLaterWidgetStore from './store/payLaterWidget';

const ignoredElements = require('./vue-constants-config').ignoredElements;

const i18n = createI18n({
    legacy: false,
    locale: 'global',
    messages: {
        global: window.vue.translations
    }
});

const payLaterWidgetTranslationsi18 = window.payLaterWidget ? createI18n({
    legacy: false,
    locale: 'global',
    messages: {
        global: window.payLaterWidget.translations
    }
}) : null;

const mountPayLaterWidget = () => {
    createApp(PayLaterWidget).use(payLaterWidgetTranslationsi18).use(payLaterWidgetStore).mount('#payLaterWidget');
};

const beforeMountVueApps = (mountVueApps) => {
    if (window.UNCACHED_DATA) {
        mountVueApps();
    } else {
        window.addEventListener('uncachedDataLoaded', () => {
            mountVueApps();
        }, { once: true });
    }
};

export {
    ignoredElements,
    i18n,
    mountPayLaterWidget,
    beforeMountVueApps
};
